export var getTagProps = function (_a) {
    var routeName = _a.routeName, disabled = _a.disabled, target = _a.target, type = _a.type;
    // creating different props for different HTML tags in order to get a valid markup
    // there can't be 'href' attribute in the 'button' tag
    // there can't be 'disabled' and 'type' attributes in the 'a' tag
    return routeName ? { href: routeName, target: target } : { disabled: disabled, type: type };
};
